import en from './en';
import uk from './uk';

const langs = { en: { translation: en }, uk: { translation: uk } };

export default langs;
